import axios, { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios'
import HttpConfig from './http-config'
import { AddPendingRequest, RemovePendingRequest } from './http-cancel'
import sso from './sso'
import {Toast} from "vant";

const api = axios.create(HttpConfig)
const clientId = process.env.VUE_APP_CLIENT_ID

api.interceptors.request.use((config: AxiosRequestConfig) => {
  // headers 中包含 cancelOthers: true 的请求，会取消之前未完成的重复请求
  if (config.headers.cancelOthers) {
    delete config.headers.cancelOthers
    RemovePendingRequest(config)
    config.cancelToken = AddPendingRequest(config)
  }
  const ssoid = sso.getSsoid()
  if (ssoid) {
    config.headers['access-token'] = ssoid
    config.headers['client-id'] = clientId
  }
  return config
})

api.interceptors.response.use(
  (response: AxiosResponse) => {
    RemovePendingRequest(response.config)
    // 响应正确处理
    const data: Ajax.AjaxResponse = response.data
    if (data && data.status === 401) {
      const ssoWeb = (window as any).ssoWeb
      ssoWeb.logout().then(() => {
        //  登出后再登录重定向回登出前的页面
        window.location.href = ssoWeb.getLoginUrl(
          ssoWeb.createRedirectUrl(
            window.location.pathname + window.location.search + window.location.hash
          )
        )
        // const url = ssoWeb.getLoginUrl()
        // location.href = url
      })
    } else {
      if (data.code !== 200) {
        Toast.fail(`请求出错：${data.message}`)
        return Promise.reject(data)
      }
      return data.data
    }
  },
  (error: AxiosError) => {
    if ((error.response as any).status === 401) {
      sso.removeSsoid()
      sso.setCurrentURL()
      sso.redirectLogin()
      return
    }
    // 是否是取消请求
    if (!error.request) {
      return null
    }
    // 响应错误处理
    const status = (error.response as AxiosResponse).status
    Toast.fail(`请求出错${status}`)
    return Promise.reject(error)
  }
)

export default api
